import { lazy } from "react"

export const MenuLinksPage = lazy(() => import("./MenuLinksPage"))